import * as React from "react";
import { Card, CardContent } from "@mui/material";
import { Typography } from "@platform/design-system";

export type MetricCardProps = {
  label: string;
  value: string | number;
  helperText?: string;
};

export const MetricCard: React.FC<MetricCardProps> = ({
  label,
  value,
  helperText,
}) => (
  <Card
    elevation={1}
    sx={{
      borderRadius: 1,
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-start",
      p: 2,
      flex: 1,
    }}
  >
    <CardContent sx={{ "&:last-child": { pb: 1 }, p: 1 }}>
      <Typography variant="body-medium">
        <strong>{label}</strong>
      </Typography>
      <Typography variant="body-medium">{value}</Typography>
      {helperText && (
        <Typography
          variant="caption"
          sx={{ display: "block", mt: 0.5 }}
          color="textSecondary"
        >
          {helperText}
        </Typography>
      )}
    </CardContent>
  </Card>
);
